import Hero from "../images/hero2.jpg";
import About from "./About";
import Team from "./Team";
import Gallery from "./Gallery";
import Aftercare from "./Aftercare";
import Contact from "./Contact";
import { useRef } from "react";

function Home() {

  const aboutRef = useRef(null);

  const scrollToAbout = () => {
    if (aboutRef.current) {
      aboutRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div
        className="relative flex justify-center items-center h-[100vh] bg-fixed bg-cover bg-center pt-[4rem] mt-[4rem]"
        style={{ backgroundImage: `url(${Hero})` }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <button className="relative z-10 bg-transparent border-2 py-2 px-8 text-[2rem] sm:text-[3rem] rounded-md text-[#ffffff] mb-[8rem] hover:bg-[#3a3a3a] hover:duration-300 hover:border-none hover:scale-90" onClick={scrollToAbout}>
          tattoo studio
        </button>
      </div>
      <div ref={aboutRef}>
        <About />
      </div>
      <Team />
      <Gallery />
      <Aftercare />
      <Contact />
    </>
  );
}

export default Home;
